/** @format */

import { baseEnvironment } from '../../../shared/config/base-environment';
import { IEnvironment } from '../../../shared/config/environment.interface';

export const environment: IEnvironment = {
  ...baseEnvironment,
  pongShellUrl: 'https://edge-pong.sesio.io',
  supportUrl: 'https://edge-support.sesio.io',
  noosGatewayUrl: 'https://edge-endpoint.noos.sesio.io',
  idoAuth: {
    url: 'https://edge-id.sesio.io', issuer: 'https://edge-id.sesio.io', clientId: 'engine-web',
  },
  appName: 'Sesio Edge',
  production: false,
  env: 'edge',
};
